import { PropsWithChildren } from "react";

import classes from "./CardHeaderActions.module.css";

type Props = PropsWithChildren;

export const CardHeaderActions = ({ children }: Props) => {
  return <div className={classes.container}>{children}</div>;
};
